
import { toast } from "@/hooks/use-toast";

// Clear all auth related data from localStorage
export const clearAuthData = () => {
  console.log("Clearing all auth data");
  
  // Clear all localStorage items
  if (typeof window !== 'undefined') {
    // Clear all authentication-related items from localStorage
    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('supabase.auth') || 
          key.includes('avatar') || 
          key.includes('user') ||
          key.includes('session') || 
          key.includes('token')) {
        console.log(`Removing localStorage item: ${key}`);
        localStorage.removeItem(key);
      }
    }
    
    // Clear specific items that might be causing issues
    localStorage.removeItem('supabase.auth.token');
    localStorage.removeItem('supabase.auth.expires_at');
    localStorage.removeItem('supabase.auth.refresh_token');
  }
  
  // Clear cookies that might be storing auth information
  if (typeof document !== 'undefined') {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
      if (name.includes('supabase') || name.includes('auth') || name.includes('sb')) {
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
      }
    }
  }
};

export const handleAuthError = (error: any, errorType: string) => {
  console.error(`${errorType} error:`, error);
  
  toast({
    title: errorType === "Authentication" ? "Authentication error" : "Registration error",
    description: error.message || `Failed to ${errorType === "Authentication" ? "sign in" : "create account"}`,
    variant: "destructive",
  });
  
  throw error;
};
